import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material';

export const useStyles = makeStyles((theme: Theme) => ({
  userIcon: {
    width: theme.spacing(6),
    height: theme.spacing(6),
    marginBottom: theme.spacing(1.4375),
  },
  titleGetStarted: {
    fontFamily: 'Roboto',
    fontSize: 16,
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: -0.16,
    textAlign: 'center',
    color: '#202a2f',
    marginTop: theme.spacing(-0.1625),
  },
  subtitleGetStarted: {
    opacity: 0.5,
    fontFamily: 'Roboto',
    fontSize: 16,
    fontWeight: 500,
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: -0.16,
    textAlign: 'center',
    color: '#202a2f',
    marginTop: theme.spacing(1.95),
  },
  buttonGetStarted: {
    width: theme.spacing(19),
    height: theme.spacing(4.125),
    padding: theme.spacing(1.025),
    marginTop: theme.spacing(9.43),
    borderRadius: theme.spacing(1),
    backgroundColor: '#35a0d9',
  },
  titleButtonGetStarted: {
    fontFamily: 'Roboto',
    fontSize: 15.8,
    fontWeight: 500,
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: -0.16,
    textAlign: 'center',
    color: '#FFFFFF',
  },
}));
